/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type DeleteMeetingInput = {
    readonly meeting?: MeetingInputDelete | null;
};
export type MeetingInputDelete = {
    readonly doNotify?: boolean | null;
    readonly domainId: string;
    readonly id: string;
    readonly userId: string;
};
export type deleteMeetingMutationVariables = {
    input: DeleteMeetingInput;
};
export type deleteMeetingMutationResponse = {
    readonly deleteMeeting: {
        readonly errors: ReadonlyArray<{
            readonly key: string;
            readonly message: ReadonlyArray<string | null> | null;
            readonly reason: ReadonlyArray<string | null> | null;
        } | null> | null;
        readonly meeting: {
            readonly id: string;
            readonly userId: string;
            readonly domainId: string;
        } | null;
    } | null;
};
export type deleteMeetingMutation = {
    readonly response: deleteMeetingMutationResponse;
    readonly variables: deleteMeetingMutationVariables;
};



/*
mutation deleteMeetingMutation(
  $input: DeleteMeetingInput!
) {
  deleteMeeting(input: $input) {
    errors {
      key
      message
      reason
    }
    meeting {
      id
      userId
      domainId
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMeetingInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteMeeting",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteMeetingPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "InputError",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "key",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "reason",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "meeting",
        "storageKey": null,
        "args": null,
        "concreteType": "Meeting",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "userId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "domainId",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "deleteMeetingMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "deleteMeetingMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "deleteMeetingMutation",
    "id": null,
    "text": "mutation deleteMeetingMutation(\n  $input: DeleteMeetingInput!\n) {\n  deleteMeeting(input: $input) {\n    errors {\n      key\n      message\n      reason\n    }\n    meeting {\n      id\n      userId\n      domainId\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '97e3fd45e6d02d6feefea85ee20a44eb';
export default node;
